import { useState } from 'react';

import GoldDashboard from '../gold/GoldDashboard';
export default function GadminPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="GadminPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div><GoldDashboard/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
